import { Download, Video, X } from "lucide-react";

export function SupportAttachmentPreview({ attachment, progress, onRemove, onCancel, busy }) {
  if (!attachment) return null;
  return (
    <div className="mb-2 flex min-w-0 items-center gap-2 rounded-lg border border-current/15 p-2">
      {attachment.contentType.startsWith("video/") ? <Video className="h-10 w-10 shrink-0" /> :
        <img src={attachment.dataUrl} alt="" className="h-10 w-10 shrink-0 rounded object-cover" />}
      <div className="min-w-0 flex-1">
        <div className="truncate text-xs">{attachment.name}</div>
        <div className="text-xs opacity-70">{(attachment.file.size / 1024 / 1024).toFixed(1)} MB{progress !== null ? ` - Uploading ${progress}%` : ""}</div>
        {progress !== null && <progress aria-label="Upload progress" value={progress} max="100" className="block h-1 w-full" />}
      </div>
      <button type="button" onClick={progress !== null ? onCancel : onRemove} disabled={busy && progress === null}
        className="grid h-9 w-9 shrink-0 place-items-center rounded hover:bg-current/10 disabled:opacity-40"
        title={progress !== null ? "Cancel upload" : "Remove attachment"} aria-label={progress !== null ? "Cancel upload" : "Remove attachment"}>
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}

export function SupportAttachmentPreviews({ attachments, progress, onRemove, onCancel, busy }) {
  if (!attachments?.length) return null;
  return (
    <div className="mb-2 flex flex-wrap gap-2">
      {attachments.map((attachment, index) => (
        <div key={`${attachment.name}-${index}`} className="min-w-0 flex-1 basis-40">
          <SupportAttachmentPreview attachment={attachment} progress={index === 0 ? progress : null} busy={busy}
            onRemove={() => onRemove(index)} onCancel={onCancel} />
        </div>
      ))}
    </div>
  );
}

export function SupportVideo({ message }) {
  const videos = message.attachments?.filter((item) => item.video_url) || (message.video_url ? [message] : []);
  if (!videos.length) return null;
  return (
    <>{videos.map((video, index) => (
      <div key={`${video.video_url}-${index}`} className="mb-2 min-w-0 max-w-full">
        <video src={video.video_url} controls playsInline preload="metadata" aria-label={video.video_name || "Support video"}
          className="block max-h-64 w-full min-w-0 rounded-lg bg-black">
          <a href={video.video_url}>Download video</a>
        </video>
        <a href={video.video_url} download={video.video_name || "video.mp4"} target="_blank" rel="noreferrer"
          className="mt-1 inline-flex max-w-full items-center gap-1 text-xs underline">
          <Download className="h-3 w-3 shrink-0" /><span className="truncate">{video.video_name || "Download video"}</span>
        </a>
      </div>
    ))}</>
  );
}

export function supportMessageImages(message) {
  return message.attachments?.filter((item) => item.image_url) || (message.image_url ? [message] : []);
}
